import React from 'react';
import { compact } from 'lodash';

import { MeetTheTeamGalleryFragment } from '../../../../graphql.schema';
import { RichTextField } from '../../RichTextField/RichTextField';

import * as styles from './index.module.scss';

export const StrapiMeetTheTeamGallery = ({ people }: MeetTheTeamGalleryFragment) => {
  return (
    <div className={styles.root}>
      <div className={styles.gridWrapper}>
        {compact(people).map(({ personName, image, description, personTitle }, i) => (
          <div key={`${personName}-${i}`}>
            <div className="is-flex is-align-items-center mb-5">
              <img
                src={image?.formats?.small?.url}
                className={styles.teacherImage}
                width={image?.width}
                height={image?.height}
                loading="lazy"
              />
              <div className="ml-5">
                <h4 className="is-4 title brand-a mb-2">{personName}</h4>
                <p className="is-text-2 black-2">{personTitle}</p>
              </div>
            </div>
            <RichTextField content={`<p class="is-text-3 black-2">${description}</p>`} />
          </div>
        ))}
      </div>
    </div>
  );
};
